import type { ComponentStyleConfig } from '@chakra-ui/react';

const ProgressComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    track: {
      backgroundColor: 'primary100',
    },
    filledTrack: {
      backgroundColor: 'primary300',
    },
  },
};

export default ProgressComponentStyle;
